import React from 'react';
import PropTypes from 'prop-types';
import { formatPriceToParts } from '../../../util/localize';
import * as Styled from './WalletCard.styled';

const WalletCardView = ({
  className,
  code,
  balance,
  currency = 'USD',
  expirationDate,
  onSeeDetailsClick,
  showDetails = true
}) => {
  if (balance == null || code == null) return null;

  const [currencySymbol, value] = formatPriceToParts(balance, currency);

  const handleSeeDetailsClick = () => {
    if (onSeeDetailsClick) {
      onSeeDetailsClick({
        code,
        balance,
        currency,
        expirationDate
      });
    }
  };

  const formatExpirationDate = (date) => {
    if (!date) return null;
    return new Date(date).toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <Styled.WalletCard
      withDivider={!!expirationDate}
      className={className}
      header={
        <Styled.HeaderRow>
          <Styled.Left>
            <Styled.Label>Your Store Credit</Styled.Label>
            <Styled.Code>{code}</Styled.Code>
          </Styled.Left>

          <Styled.Right>
            <Styled.AmountRow>
              <Styled.Currency>{currencySymbol}</Styled.Currency>
              <Styled.Amount>{value}</Styled.Amount>
            </Styled.AmountRow>
            {showDetails && (
              <Styled.SeeDetails onClick={handleSeeDetailsClick}>
                See Details
              </Styled.SeeDetails>
            )}
          </Styled.Right>
        </Styled.HeaderRow>
      }
    >
      {expirationDate ? (
        <Styled.ExpirationSection>
          <Styled.ExpirationLeft>
            <Styled.ExpirationLabel>
              Expires {formatExpirationDate(expirationDate)}
            </Styled.ExpirationLabel>
          </Styled.ExpirationLeft>

          <Styled.ExpirationRight>
            <Styled.ExpirationAmount>
              {currencySymbol}
              {value}
            </Styled.ExpirationAmount>
          </Styled.ExpirationRight>
        </Styled.ExpirationSection>
      ) : (
        <></>
      )}
    </Styled.WalletCard>
  );
};

WalletCardView.propTypes = {
  className: PropTypes.string,
  code: PropTypes.string.isRequired,
  balance: PropTypes.number.isRequired,
  currency: PropTypes.string,
  expirationDate: PropTypes.string,
  onSeeDetailsClick: PropTypes.func,
  showDetails: PropTypes.bool
};

WalletCardView.defaultProps = {
  className: undefined,
  currency: 'USD',
  expirationDate: undefined,
  onSeeDetailsClick: undefined
};

export default WalletCardView;
